import { AiRecommendationsApi } from '@calm/evexia-web-sdk/generated/lib/api/ai-recommendations-api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `AiRecommendationsApi`
 * @param accessToken
 * @returns
 */
export default function createAiRecommendationsApi(
    accessToken: () => Promise<string>
) {
    return createApi(AiRecommendationsApi, accessToken);
}
